import Vue from "vue";
import VueResource from "vue-resource";

window.Vue = Vue;

window.Vue.use(VueResource)

window.localTimezone = "America/Chicago";

//import moment from "moment-timezone";
window.moment = require('moment-timezone');
import sortBy from "lodash/sortBy";
import orderBy from "lodash/orderBy";
window.sortBy = sortBy;
window.orderBy = orderBy;
window.audio = true;


// WEBPACK FOOTER //
// ./src/js/global.js